<template>
    <div class="news-qrcode-box">
        <div class="news-box">
            <div class="arrow-icon"></div>
            <div class="title-box yuyue-text">
                <div class="title"></div>
                <div class="sub-title heiti-text">三端互通旗舰升级，特色新服即将上线</div>
            </div>
            <div class="tab-box">
                <div class="tab-item" :class="{
                    active: activeTab === item.sort
                }" v-for="item in serverList" :key="item.sort" @click="tabChange(item)">
                    {{ item.name }}
                </div>
            </div>
            <div class="swiper-bg">
                <div class="swiper-box" v-for="item in serverList" :key="item.sort">
                    <news-swiper :swiperList="swiperListObj[item.sort]" v-if="activeTab === item.sort" />
                </div>
            </div>
            <div class="appoint-box">
            </div>
            <div class="appoint-award" v-if="!!currentSwieperAwardList.length">
                <div class="award-box">
                    <div class="award-icon" v-for="tar in currentSwieperAwardList" :key="tar" @click="awardHandle(tar)">
                        <Image v-if="!!getIcon(tar)" :src="getIcon(tar)" :size="{ width: 58, height: 58 }" />
                    </div>
                </div>
                <div class="text">
                    {{ !!init_data?.act_data?.is_appointed ? currentSwieperTip : '预约奖励' }}
                </div>
            </div>
            <div class="empty" v-else></div>
            <div class="order-box">
                <div class="f-row f-zhu-center">
                    <template v-if="!init_data?.act_data?.is_appointed">
                        <ItemContainer src="qipao" class="qipao t-center p-l-40 p-t-10">
                            <span class="t-white t-s-16">即得现金，最高888元</span>
                        </ItemContainer>
                        <TxButton class="m-b-10 t-btn" src="anniu_2" name="预约新服" @click="emits('order')">
                            预约新服
                        </TxButton>
                    </template>
                    <TxButton v-else class="m-b-10 t-btn" src="anniu_2" name="前往官网" @click="jumpLink">
                        前往官网
                    </TxButton>
                </div>
                <TxButton v-if="!init_data?.act_data?.is_appointed" src="yuan" class="yuan t-btn" name="前往官网"
                    @click="jumpLink">
                    前往<br />官网</TxButton>
            </div>
        </div>
        <div class="qr-section">
            <div class="tab-header">
                <div class="tab-item" :class="{
                    active: qrActiveTab === item.sort
                }" @click="changeQrTab(item)" v-for="item in qrTabList" :key="item.sort">
                    {{ item.name }}
                </div>
            </div>
            <div class="qrcode-box">
                <div class="qrcode-item" v-for="item in qrcodeList" :key="item.sort">
                    <div class="qr-bg">
                         <img :src="getQrIconUrl(item)" alt="">
                    </div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </div>
        </div>
        <!-- <div class="hezuo-section">
            <div class="title"></div>
        </div> -->
    </div>
</template>

<script lang="ts" setup>
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
const { isWeChat, isMiniProgram } = useWeChatEnv();
import { ref, inject, defineAsyncComponent, onMounted, computed } from 'vue';
import eventEmitter from '@utils/event';
import { jumpLinkObj } from '../constant';
import config from '@img/config.json';
const { login_status, error_codemsg, init_data } = inject('GlobalData');
const { activity_config } = inject('GlobalStore');
const emits = defineEmits(['showAwardTip', 'order'])

const NewsSwiper = defineAsyncComponent({
    loader: () => import('./news_swiper.vue'),  // 轮播组件
});

const activeTab = ref(1)
const serverList = ref([
    { sort: 1, award_key: 3, name: '开天互通版' },
    { sort: 2, award_key: 2, name: '天下贰·经典版', tip: '前往天下贰·经典版可领' },
    { sort: 3, award_key: 1, name: '天下3·年度服', tip: '前往弱水三千服可领' },
    { sort: 4, award_key: 4, name: '天下手游' },
])
const swiperList = ref([
    { sort: 1 },
    { sort: 2 },
    { sort: 3 },
])
const swiperListObj = {
    1: [
        { icon: 'hutong_1' },
        { icon: 'hutong_2' },
        { icon: 'hutong_3' },
        { icon: 'hutong_4' },
        { icon: 'hutong_5' },
    ],
    2: [
        { icon: 'jingdian_1' },
    ],
    3: [
        { icon: 'saiji_1' },
    ],
    4: [
        { icon: 'shouyou_1' },
        { icon: 'shouyou_2' },
    ]
}

const qrActiveTab = ref(1)
const qrTabList = ref([
    {
        sort: 1, name: '天下：万象', qrcodeList: [
            { sort: 1, icon: 'qr_01', name: '抖音' },
            // { sort: 2, icon: 'qr_01', name: 'TapTap' },
        ]
    },
    {
        sort: 2, name: '天下3', qrcodeList: [
            { sort: 1, icon: 'qr_03', name: '公众号' },
            { sort: 2, icon: 'qr_02', name: '抖音' },
        ]
    },
    {
        sort: 3, name: '天下贰', qrcodeList: [
            { sort: 1, icon: 'qr_05', name: '公众号' },
            { sort: 2, icon: 'qr_04', name: '抖音' },
        ]
    },
    {
        sort: 4, name: '天下贰·经典版', qrcodeList: [
            { sort: 1, icon: 'qr_07', name: '公众号' },
            { sort: 2, icon: 'qr_06', name: '抖音' },
        ]
    },
])

const currentSwieperAwardList = computed(() => {
    const awardKey = serverList.value.find(tar => tar.sort === activeTab.value)?.award_key
    if (!awardKey) {
        return []
    }
    return activity_config.value?.appoint_award_data?.[awardKey] || []
})

const currentSwieperTip = computed(() => {
    return serverList.value.find(tar => tar.sort === activeTab.value)?.tip
})

const qrcodeList = computed(() => {
    return qrTabList.value.find(item => item.sort === qrActiveTab.value)?.qrcodeList || []
})

function beforeCheck() {
    if (!(isMiniProgram.value || isWeChat.value)) {
        // eventEmitter.emit('toast', {
        //     text: '请使用微信打开此活动',
        //     duration: 2,
        // });
        return false
    }
    if (!login_status.value) {
        eventEmitter.emit('login');
        return false
    }
    if (!!error_codemsg.value) {
        eventEmitter.emit('toast', {
            text: error_codemsg.value,
        });
        return false
    }
    return true
}

function orderHandle() {
    const ispass = beforeCheck()
    if (!ispass) return
}

function tabChange(item: any) {
    activeTab.value = item.sort
}


function handle_chou() {
    eventEmitter.emit('chou')
}

function handle_share() {
    eventEmitter.emit('share')
}

function handle_invite() {
    eventEmitter.emit('invite')
}

function jumpLink() {
    window.open(jumpLinkObj.officialWeb)
}

function getIcon(item_id) {
    return activity_config.value.item_data?.[item_id]?.icon
}

function awardHandle(item_id: any) {
    if (!!item_id) {
        emits("showAwardTip", item_id)
    }
}

function changeQrTab(item) {
    qrActiveTab.value = item.sort
}

function getQrIconUrl(item) {
    return `${config[item.icon].src}.png`;
}
</script>

<style lang="scss" scoped>
.yuyue-text {
    color: #aabfca;
    font-size: 3.6vw;
    font-family: "KaiTi", "楷体", serif;
}

.heiti-text {
    color: #aabfca;
    font-size: 3.6vw;
    font-family: "SimHei", "黑体", serif;
}

.news-qrcode-box {
    margin-top: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .news-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;

        .arrow-icon {
            @include bg('jiantou');
            margin-bottom: 70px;
        }

        .title-box {
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
                // font-size: 47px;
                // background: linear-gradient(180deg, #ffffff 0%, #ffffff 10%, #9fd3eb 70%, #9fd3eb 100%);
                // color: transparent;
                // background-clip: text;
                @include bg('zi_4')
            }

            .sub-title {
                display: flex;
                align-items: center;
                font-size: 20px;
                color: #65778B;

                &::before {
                    content: '';
                    @include bg('xian');
                    margin-right: 10px;
                }

                &::after {
                    content: '';
                    @include bg('xian');
                    transform: rotateY(180deg);
                    margin-left: 10px;
                }
            }
        }

        .tab-box {
            @include bg('db_5');
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            color: #4c5e72;
            box-sizing: border-box;
            padding-top: 10px;
            padding-left: 10px;
            padding-right: 10px;
            margin-bottom: 10px;
            font-size: 22px;

            .tab-item {
                // flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
                position: relative;

                &.active {
                    color: #ffffff;

                    &::after {
                        content: '';
                        @include bg('db_5_xz');
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translate(-50%, 50%);
                    }
                }
            }
        }

        .swiper-bg {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            @include bg('xiankuang');
        }

        .swiper-box {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

        }

        .empty {
            height: 90px;
            margin-top: 15px;
        }

        .appoint-award {
            position: relative;
            // right: 0px;
            // bottom: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            @include bg('yuyue');
            box-sizing: border-box;
            padding-top: 5px;
            margin-top: 15px;


            .text {
                position: absolute;
                left: 50%;
                top: 0;
                transform: translate(-50%, -50%);
                width: 100%;
                text-align: center;
                font-size: 18px;
                color: #dfc184;
            }

            .award-box {
                display: flex;
                align-items: center;

                .award-icon {
                    @include bg('daojuge60x60');
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        .order-box {
            position: relative;
            margin-top: 20px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .yuan {
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translate(0, calc(-50% - 10px));
                font-size: 18px;
                color: #fff;
                box-sizing: border-box;
                padding-left: 4px;
            }
        }
    }

    .qr-section {
        margin-top: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .tab-header {
            @include bg('qr_di');
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            color: #737f90;
            font-size: 22px;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;


            .tab-item {
                position: relative;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                &.active {
                    color: #4277bf;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        transform: translate(-50%, 0);
                        @include bg('qe_xuanzhong');
                    }
                }
            }

        }

        .qrcode-box {
            @include bg('qr_di2');
            display: flex;
            align-items: center;
            justify-content: center;

            .qrcode-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 60px;

                &:last-child {
                    margin-right: 0;
                }

                .qr-bg {
                    // @include bg('erweima');

                    img {
                        width: 181px;
                        height: 181px;
                    }
                }

                .name {
                    @include bg('qr_zidi');
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 20px;
                    color: #fff;
                    margin-top: 6px;
                }
            }
        }
    }

    .hezuo-section {
        margin-top: 50px;
        .title {
            @include bg('huoban');
        }
    }


    .footer-box {
        width: 100%;
        box-sizing: border-box;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 40px;

        .icon1 {
            @include bg('wyyx_2');
        }

        .icon2 {
            @include bg('logo_3');
        }

        .icon3 {
            @include bg('logo_4');
        }
    }
}

.qipao {
    position: absolute;
    top: -30px;
    left: 300px;
    box-sizing: border-box;
}
</style>